import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import Information from "./pages/information";
import ThemeManagementPage from "./pages/theme";
import MainManagementPage from "./pages/main";
import GiftSettingsPage from "./pages/gift";
import WishSettingsPage from "./pages/wish";
import AlbumSettingsPage from "./pages/album";
import ActivityPage from "./pages/activity";
import { EventDataProvider } from "./EventDataContext";
import EventsContent from "./EventsContent";
import { onAuthStateChanged, getAuth, signOut } from "firebase/auth";
import { useNavigate } from "react-router-dom";


const TabHandler = {
  information: "information",
  main: "main",
  theme: "theme",
  gift: "gift",
  advance: "advance",
  wish: "wish",
  album: "album",
  activity: "activity",
};

export default function Events(props) {
  const { id } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    const auth = getAuth();
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (!user) {
        navigate("/login");
      }
    });

    return () => unsubscribe();
  }, [navigate]);

  const steps = [
    {
      key: TabHandler.information,
      label: "Event Information",
      component: <Information {...props} />,
      group: "settings",
    },
    {
      key: TabHandler.theme,
      label: "Theme Management",
      component: <ThemeManagementPage {...props} />,
      group: "settings",
    },
    {
      key: TabHandler.main,
      label: "Main Page",
      component: <MainManagementPage {...props} />,
      group: "settings",
    },
    {
      key: TabHandler.gift,
      label: "Gift Setting",
      component: <GiftSettingsPage {...props} />,
      group: "settings",
    },
    {
      key: TabHandler.wish,
      label: "Wish Form Settings",
      component: <WishSettingsPage {...props} />,
      group: "settings",
    },
    {
      key: TabHandler.album,
      label: "Album Setting",
      component: <AlbumSettingsPage {...props} />,
      group: "settings",
    },
    {
      key: TabHandler.activity,
      label: "Activity",
      component: <ActivityPage {...props} />,
      group: "activity",
    },
  ];

  return (
    <EventDataProvider eventId={id}>
      <EventsContent steps={steps} TabHandler={TabHandler} eventId={id} />
    </EventDataProvider>
  );
}
